import { MatterSettings, MatterTab } from '@/components/matter';
import { useCurrentMatter } from '@/components/contexts/CurrentMatterContext';
import { TooltipProvider } from "@/components/ui/tooltip";
import { useShellHeader, useShellHeaderBelow } from '@/components/contexts/ShellHeaderContext';
import { useMemo } from 'react';

const Settings = () => {
  const { matter } = useCurrentMatter();
  useShellHeader({
    header: matter.name,
  });
  useShellHeaderBelow(
    useMemo(
      () => <MatterTab activeTab="settings" matter={matter} />,
      [matter],
    ),
  );

  return (
    <TooltipProvider>
      <div className="px-6 pt-6 pb-4">
        <MatterSettings matter={matter} />
      </div>
    </TooltipProvider>
  );
};
export default Settings;
